import { getAppBasePath } from './serviceWorkerHelpers'

export function resolveAppPath(rawPath, fallback = '/notificaciones') {
  const value = String(rawPath || '').trim()
  if (!value) return resolveAppPath(fallback, '/notificaciones')
  if (/^https?:\/\//i.test(value)) return value

  const base = getAppBasePath()
  if (base === '/') {
    return value.startsWith('/') ? value : `/${value}`
  }

  if (value.startsWith('/')) {
    return `${base}${value}`
  }
  return `${base}/${value}`
}

